@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <!-- Header -->
  <div class="mb-3 flex items-center gap-2">
    <mat-icon class="!text-base text-blue-600">account_balance_wallet</mat-icon>
    <h3 class="text-secondary text-sm font-semibold uppercase tracking-wide">Payment Methods</h3>
  </div>

  @if (loading) {
    <div class="space-y-3">
      @for (_ of [1, 2, 3, 4]; track $index) {
        <div class="h-10 animate-pulse rounded-lg bg-gray-100"></div>
      }
    </div>
  } @else if (error) {
    <div class="flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">
      <mat-icon class="!text-base">error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>
  } @else if (!data || !data.methods?.length) {
    <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
      <mat-icon class="!text-3xl text-gray-300">account_balance_wallet</mat-icon>
      <span class="text-xs text-gray-400">No payment data available</span>
    </div>
  } @else {
    <!-- Total amount tile -->
    <div class="mb-3 rounded-lg border border-blue-100 bg-blue-50 p-3 text-center">
      <div class="text-[10px] uppercase tracking-wide text-gray-500">Total Collected</div>
      <div class="mt-0.5 text-sm font-bold text-blue-700" [innerHTML]="data.total | amount"></div>
    </div>

    <!-- Method rows -->
    <div class="space-y-2">
      @for (m of data.methods; track m.method; let i = $index) {
        @let cfg = getColor(i);
        <div class="flex items-center gap-2.5">
          <!-- Icon badge -->
          <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-gray-100">
            <mat-icon class="!text-sm text-gray-500">{{ getMethodIcon(m.method) }}</mat-icon>
          </div>

          <!-- Label + bar -->
          <div class="min-w-0 flex-1">
            <div class="mb-1 flex items-center justify-between">
              <span class="text-xs font-semibold text-gray-700">{{ m.method }}</span>
              <span class="text-[10px] font-bold text-gray-500">{{ m.pct }}%</span>
            </div>
            <div class="h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
              <div class="h-full rounded-full transition-all" [ngClass]="cfg.bar" [style.width.%]="m.pct"></div>
            </div>
          </div>

          <!-- Amount -->
          <div class="shrink-0 text-right">
            <span class="text-xs font-bold text-gray-700" [innerHTML]="m.amount | amount"></span>
          </div>
        </div>
      }
    </div>
  }
}
